import { type RouteRecordRaw } from 'vue-router'

import { useGuestGenresStore } from './store/guestgenres.store'

export const GenresRouter: RouteRecordRaw[] = [
  {
    path: '/genres',
    component: async () => import('./Genres.vue'),
    async beforeEnter() {
      await useGuestGenresStore.getState().getGenres()
    },
  },
]
